import React from 'react';

import { IIconProps, TIconType } from '../interface';

const DragHandleIcon: TIconType = (props?: IIconProps) => {
	const { color } = props || {};

	return (
		<svg
			data-testid='drag-handle'
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
		>
			<circle
				cx='6'
				cy='4'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
			<circle
				cx='10'
				cy='4'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
			<circle
				cx='6'
				cy='8'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
			<circle
				cx='10'
				cy='8'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
			<circle
				cx='6'
				cy='12'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
			<circle
				cx='10'
				cy='12'
				fill={color ? color : '#6B7280'}
				r='1'
			/>
		</svg>
	);
};

export default DragHandleIcon;
